module.exports = __webpack_public_path__ + "img/banner-r-shadow-3.2a7053ff.png";